import React from "react";
import { Box, Typography, Button } from "@mui/material";

const HeroBanner = ({ onClick }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundImage: `url(/images/grazeboxes/charcuterie_bg.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        py: { xs: 10, sm: 12 },
        px: 2,
        height: { xs: 500, md: 600 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}>
      <Box
        sx={{
          width: { xs: "90%", sm: "auto" },
          backgroundColor: "#ffe6e6",
          color: "#000",
          borderRadius: "20px",
          px: { xs: 3, sm: 6 },
          py: { xs: 4, sm: 6 },
          textAlign: "center",
        }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontFamily: "Moul",
            mb: 2,
            fontSize: { xs: "1.8rem", sm: "3rem" },
          }}>
          Elevate Your Events with Our Grazing Boxes
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            fontFamily: "Inter",
            mb: 3,
            fontSize: { xs: "1rem", sm: "1.5rem" },
          }}>
          Curated for freshness, taste, and beauty.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={onClick}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            fontSize: { xs: "1rem", sm: "1.2rem" },
            borderRadius: "8px",
          }}>
          Shop Now
        </Button>
      </Box>
    </Box>
  );
};

export default HeroBanner;
